function root(el, data, Alpine) {
    Alpine.bind(el, {
        'x-data'() {
            return {
                skip: 1,
                atBeginning: false,
                atEnd: false,
                ariaLabel: "carousel",
                autoplay: false,
                autoplayId: null,
                duration: 3000,
                slides: 0,
                currentSlide: 0,
                slider: null,
                currentBreakpoint: 'base',
                breakpoints: {},
                next() {
                    this.to((current, offset) => current + (offset * this.skip));
                },
                prev() {
                    this.to((current, offset) => current - (offset * this.skip))
                },
                first() {
                    this.slider.scrollTo({ left: 0, behavior: 'smooth' });
                },
                last() {
                    let remaining = this.slider.scrollWidth;
                    this.slider.scrollTo({ left: remaining, behavior: 'smooth' });
                },
                toIndex(index) {
                    const children = this.slider.children;
                    if (index < 0 || index >= children.length) return;
                    const child = children[index];
                    const offsetLeft = child.offsetLeft;
                    this.slider.scrollTo({ left: offsetLeft, behavior: 'smooth' });
                },
                to(strategy) {
                    let current = this.slider.scrollLeft;
                    let offset = this.slider.firstElementChild.getBoundingClientRect().width;
                    console.log(this.slider.firstElementChild);
                    this.slider.scrollTo({ left: strategy(current, offset), behavior: 'smooth' });
                },
                getResponsiveOption($value) {
                    // check its not dodge
                    if (this.getResponsiveOptions().includes($value)) {
                        
                        let val = this[$value];
                        if (this.currentBreakpoint === 'base') {
                            return val;
                        }
                        
                        if (
                            Object.keys(this.breakpoints).includes(this.currentBreakpoint)
                            && Object.keys(this.breakpoints[this.currentBreakpoint]).includes($value)
                        ) {
                            return this.breakpoints[this.currentBreakpoint][$value];
                        }
                        return val;
                        
                    }
                },
                getResponsiveOptions() {
                    return [
                        'skip',
                        'autoplay',
                    ];
                },
                getBreakpoint() {
                    const width = window.innerWidth;
                    if (width >= 1536) return '2xl';
                    if (width >= 1280) return 'xl';
                    if (width >= 1024) return 'lg';
                    if (width >= 768) return 'md';
                    if (width >= 640) return 'sm';
                    return 'base';
                },
                triggerAutoplay() {

                    console.log('autoplay');
                    if (!this.atEnd) {
                        this.next();
                    } else {
                        this.first();
                    }
                
                },
                ...data
            }
        },
        'x-init'() {
            this.slider = this.$el.querySelector('[x-slider\\:slider-list]');
            this.slides = this.slider.childElementCount;
            this.currentBreakpoint = this.getBreakpoint();
            if (this.getResponsiveOption('autoplay')) {
                this.autoplayId = this.autoplay && setInterval( () => {
                    if (!this.atEnd) {
                        this.next();
                    } else {
                        this.first();
                    }
                }, this.duration);
            }
        },
        'x-on:resize.window'() {
            this.currentBreakpoint = this.getBreakpoint();
            // autoplay
            if (this.getResponsiveOption('autoplay')) {
                this.autoplayId = this.autoplay && setInterval( () => {
                    if (!this.atEnd) {
                        this.next();
                    } else {
                        this.first();
                    }
                }, this.duration);
            } else {
                // don't want this anymore
                if (this.autoplayId) {
                    clearInterval(this.autoplayId);
                    this.autoplayId = null;
                }
            }
        }
    });
}

function container(el, Alpine) {
    Alpine.bind(el, {
        'x-on:keydown.right'() { this.next() },
        'x-on:keydown.left'() { this.prev() },
        'tabindex': "0",
        'role': 'region',
        ':aria-label'() { return this.ariaLabel },
    });
}

function buttonPrev(el, Alpine) {
    Alpine.bind(el, {
        'x-on:click'() { this.prev() },
        ':aria-disabled'() { return this.atBeginning },
        ':tabindex'() { return this.atEnd ? -1 : 0 }
    })
}

function buttonNext(el, Alpine) {
    Alpine.bind(el, {
        'x-on:click'() { this.next(); },
        ':aria-disabled'() { return this.atEnd },
        ':tabindex'() { return this.atEnd ? -1 : 0 }
    })
}

function sliderList(el, Alpine) {
    Alpine.bind(el, {
        'tabindex': '0',
        'role':'listbox',
        'x-ref': 'sliderlist',
        ':aria-label'() { return this.ariaLabel },
    })
}

function slide(el, Alpine) {
    Alpine.bind(el, {
        'role': 'option',
        'x-intersect:enter.threshold.05'() {
            let slideEls = this.$el.parentElement.children;
            this.currentSlide = Array.from(slideEls).indexOf(this.$el);
            // If this is the first slide.
            if (slideEls[0] === this.$el) {
                this.atBeginning = true
            // If this is the last slide.
            } else if (slideEls[slideEls.length-1] === this.$el) {
                this.atEnd = true
            }
        },
        'x-intersect:leave.threshold.05'() {
            let slideEls = this.$el.parentElement.children

            // If this is the first slide.
            if (slideEls[0] === this.$el) {
                this.atBeginning = false
            // If this is the last slide.
            } else if (slideEls[slideEls.length-1] === this.$el) {
                this.atEnd = false
            }
        },
    })
}

function focusable(el, Alpine) {
    Alpine.bind(el, {
        'x-intersect:enter'() {
            this.$el.removeAttribute('tabindex')
        },
        'x-intersect:leave'() {
            this.$el.setAttribute('tabindex', '-1')
        },
    })
}


export default function (Alpine) {
    Alpine.directive('slider', (el, {value, expression}, {evaluate, Alpine}) => {
        // this is the top level component x-search
        if (!value) {
            root(el, evaluate(expression), Alpine);
        }
        if (value == 'container') {
            container(el, Alpine);
        }
        if (value == 'next-button') {
            buttonNext(el, Alpine);
        }
        if (value == 'prev-button') {
            buttonPrev(el, Alpine);
        }
        if (value == 'slider-list') {
            sliderList(el, Alpine);
        }
        if (value == 'slide') {
            slide(el, Alpine);
        }
        if (value == 'focusable') {
            focusable(el, Alpine);
        }
    }).before('bind');
}